import { render, staticRenderFns } from "./FoodCourtViewOrder.vue?vue&type=template&id=a1741f78&scoped=true"
import script from "./FoodCourtViewOrder.vue?vue&type=script&lang=js"
export * from "./FoodCourtViewOrder.vue?vue&type=script&lang=js"
import style0 from "./FoodCourtViewOrder.vue?vue&type=style&index=0&id=a1741f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1741f78",
  null
  
)

export default component.exports